export default "__VITE_ASSET__BaxgzkJk__"